import React, { useState } from "react";
import CommonCalendar from "../CommonCalendar";
import AmountInputField from "../CommonInputFields/AmountInputField";
import TextInputField from "../CommonInputFields/TextInputField";
import PrimaryButton from "../CommonButtons/PrimaryButton";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

import { reminderTxnCreate } from "../../../redux/features/reminderTransaction";
import CommonToast from "../CommonToast";
import {
  GlobalConfiguration,
  IntervalConfiguration,
} from "../../../utils/configurationProvider";
import ICONS from "../../../assets/Icons";

const ReminderFormPopup = ({
  navigate,
  setCreateShow,
  handleReminderAction,
}) => {
  const dispatch = useDispatch();
  const services = useSelector((state) => state.refreshToken.services);
  const [startDate, setStartDate] = useState(null);
  const [animate, setAnimate] = useState(false);
  const [inputText, setInputText] = useState("");
  const [isCreateLoading, setIsCreateLoading] = useState(false);
  const [txnPayLoad, setTxnPayLoad] = useState({ amount: "", amountWords: "" });

  const formatDateForPayload = (date) => {
    if (!date) return "";
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = d.toLocaleString("default", { month: "short" });
    const year = d.getFullYear();
    return `${day} ${month}, ${year}`;
  };

  const handleDateChange = (dates) => {
    const selected = Array.isArray(dates) ? dates[0] : dates;
    setStartDate(selected);
  };

  const allowedValue = (value) => {
    const num = parseFloat(value);
    return !isNaN(num) && num >= GlobalConfiguration?.lengthCheckZero;
  };

  const handleAmountChange = (value) => {
    if (value[0] !== "0") {
      const numericValue = value.replace(/[^0-9.]/g, "");
      if (
        allowedValue(numericValue) ||
        numericValue.length === GlobalConfiguration?.lengthCheckZero
      ) {
        setTxnPayLoad({ amount: numericValue });
      }
    }
  };

  const handleCancel = () => {
    setStartDate(null);
    setTxnPayLoad({ amount: "", amountWords: "" });
    setInputText("");
    setCreateShow(false);
  };

  const showToast = (message) => {
    CommonToast({
      text: message,
      icon: "https://q2pay.in/new_assets/gifs/inputloader_white.gif",
      variant: "var(--processing)",
      buttonNeeded: false,
      btnProps: {
        enabledBgColor: "var(--primary-bg)",
        enabledTextColor: "var(--text-primary)",
        btnText: "",
        handleFunction: () => {},
        icon: "",
        btnType: "button",
        isDisabled: false,
        hoverOption: "white",
      },
    });
  };

  const handleCreate = async () => {
    setIsCreateLoading(true);
    showToast("Creating reminder.");

    const paramsData = {
      reminder_date: formatDateForPayload(startDate),
      amount: txnPayLoad.amount ?? "",
      remark: inputText.trim(),
    };

    try {
      const res = await dispatch(
        reminderTxnCreate({ paramsData, navigate, services }),
      );

      toast.dismiss();

      if (res?.payload?.status) {
        CommonToast({
          text: "Reminder created successfully.",
          icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
        handleReminderAction();
        setCreateShow(false);
        return;
      }

      const errorMessage =
        res?.payload?.errors?.remark?.[0] ||
        res?.payload?.errors?.reminder_date?.[0] ||
        res?.payload?.errors?.base?.[0] ||
        "Failed to create reminder.";

      CommonToast({
        text: errorMessage,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    } catch (error) {
      toast.dismiss();
      CommonToast({
        text: "Failed to create reminder.",
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    } finally {
      setIsCreateLoading(false);
      setCreateShow(false);
    }
  };

  const isCreateEnabled =
    inputText.trim().length >= GlobalConfiguration?.lengthCheckThree &&
    !!startDate;

  return (
    <div
      className="flex w-full justify-center items-center m-auto top-1/2 left-1/2 fixed z-z-index-modal p-padding-sm"
      style={{ transform: "translate(-50%, -50%)" }}
    >
      <div
        className={`w-full Qmd:w-small-popup-width max-h-graphic_rectangle_height_xl flex flex-col px-padding-md py-padding-md bg-primary-bg rounded-border-radius-md animate-none  ${animate ? "Qmd:animate-slideInFromLeft" : "Qmd:animate-slideInFromRight"}`}
      >
        <div className="flex flex-col gap-gap-xs">
          <p className={`text-text-primary  text-font-md font-semibold`}>
            Set new reminder
          </p>
          <p className="text-font-sm text-text-secondary font-normal ">
            Set a reminder to make the transaction on the specified date.
          </p>
        </div>
        <div className="flex flex-col gap-gap-md w-width-full">
          <div className="mt-margin-md flex-1">
            <CommonCalendar
              isFullWidthRequired={true}
              startDate={startDate}
              handleDateChange={handleDateChange}
              type="big"
              selectionType="single"
              minDate={new Date()}
            />
          </div>

          <AmountInputField
            variant={"default"}
            placeholder="Amount (optional)"
            bgColor="var(--primary-bg)"
            fgColor="var(--text-primary)"
            onInput={handleAmountChange}
            fontKind="big"
            isFullWidth={true}
            value={txnPayLoad.amount}
          />

          <TextInputField
            variant={
              inputText.trim().length >= GlobalConfiguration?.lengthCheckThree
                ? "verified"
                : "default"
            }
            placeholder="Reminder remark (3-150 char)"
            fontKind={"big"}
            bgColor="var(--primary-bg)"
            fgColor="var(--text-primary)"
            value={inputText}
            onInput={(e) => {
              const newValue = e.target.value;
              if (newValue !== inputText) {
                setInputText(newValue.substring(0, 150));
              }
            }}
            isFullWidth={true}
            adornment=""
          />

          <div className="gap-gap-sm flex justify-end">
            <PrimaryButton
              btnText={"Cancel"}
              handleFunction={() => {
                setAnimate(true);
                setTimeout(() => {
                  handleCancel();
                }, IntervalConfiguration.intervalSemiMid);
              }}
              enabledTextColor="var(--text-primary)"
              disabledTextColor="var(--text-primary)"
              enabledBgColor="var(--primary-bg)"
              disabledBgColor="var(--primary-bg)"
              outLineColor="var(--text-primary)"
              hoverOption="white"
              inActiveVariantNeeded
              isLoaderNeeded={false}
              isDisabled={isCreateLoading}
            />

            <PrimaryButton
              btnText={"Create"}
              handleFunction={() => {
                if (
                  !startDate ||
                  inputText.trim().length <
                    GlobalConfiguration?.lengthCheckThree
                )
                  return;
                setAnimate(true);
                setTimeout(() => {
                  handleCreate();
                }, IntervalConfiguration.intervalSemiMid);
              }}
              enabledTextColor="var(--text-primary)"
              disabledTextColor="var(--text-primary)"
              enabledBgColor="var(--positive-act)"
              disabledBgColor="var(--text-disabled)"
              hoverOption="black"
              isDisabled={!isCreateEnabled}
              inActiveVariantNeeded
              isLoaderNeeded={true}
              isLoading={isCreateLoading}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReminderFormPopup;
